// countdown-timer.component.ts
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-countdown-timer',
  standalone: true,
  templateUrl: './countdown-timer.component.html'
})
export class CountdownTimerComponent implements OnInit, OnDestroy {
  @Input() minutes: number = 0;
  @Input() seconds: number = 0;
  @Output() countdownCompleted = new EventEmitter<void>();

  private subscription!: Subscription;
  totalSeconds!: number;
  initialTotalSeconds!: number;

  displayMinutes: string = '00';
  displaySeconds: string = '00';
  progressPercentage: number = 100;
  circleColor: string = 'stroke-green-500'; // Tailwind classes

  ngOnInit(): void {
    this.totalSeconds = this.minutes * 60 + this.seconds;
    this.initialTotalSeconds = this.totalSeconds;
    this.updateDisplay();
    this.startCountdown();
  }

  startCountdown() {
    this.subscription = interval(1000).subscribe(() => {
      if (this.totalSeconds > 0) {
        this.totalSeconds--;
        this.updateDisplay();
        this.updateProgress();
      } else {
        this.subscription.unsubscribe();
        this.countdownCompleted.emit();
      }
    });
  }

  updateDisplay() {
    const mins = Math.floor(this.totalSeconds / 60);
    const secs = this.totalSeconds % 60;

    this.displayMinutes = String(mins).padStart(2, '0');
    this.displaySeconds = String(secs).padStart(2, '0');
  }

  updateProgress() {
    this.progressPercentage = (this.totalSeconds / this.initialTotalSeconds) * 100;

    if (this.progressPercentage <= 25) {
      this.circleColor = 'stroke-red-500';
    } else if (this.progressPercentage <= 50) {
      this.circleColor = 'stroke-yellow-500';
    } else {
      this.circleColor = 'stroke-green-500';
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
